export enum ConsentSources {
    POPUP = 'popup',
    ACCOUNT = 'account',
    LP = 'lp'
}
